<template>
  <div>
    <div :class="[{'no-options':noOptions,'inline-label':inlineLabel}]" class="dropdown">
      <div class="label-title" v-if="!inlineLabel&&label">{{label}}</div>
      <div
        class="input"
        @keypress="keypress"
        @mousedown="setFocus"
        :class="{'active':showOptions,'error':error&&!showOptions}"
      >
        <img v-if="leftIcon" :src="leftIcon" alt />
        <div class="text-container" :class="{'padding-left':!leftIcon}">
          <div v-if="inlineLabel&&label">{{label}}</div>
          <div class="display-text">{{text}}</div>
          <div v-show="!value&&!inlineLabel&&description" class="desc">{{description}}</div>
          <input
            type="text"
            :value="value"
            v-bind="$attrs"
            @blur="inputBlur"
            @focus="showOptions=true"
          />
        </div>
        <img v-if="innerRightIcon" class="right-icon" :src="innerRightIcon" alt />
      </div>
      <div
        tabindex="-1"
        v-show="showOptions"
        class="dropdown-panel"
        @blur="showOptions=false"
        @mouseup="showOptionsLock = false"
        @mousedown="showOptionsLock = true"
      >
        <div
          :key="i"
          class="option"
          v-for="(opt,i) in data"
          @mousedown="changeValue(opt._key)"
          :class="{current:value&&value===opt._key}"
        >{{opt._value}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import validatable from "../validatable";
import images from "../../../core/images";
export default {
  name: "dropdown",
  inheritAttrs: false,
  mixins: [validatable],
  created() {
    if (
      this.value !== null &&
      this.value !== undefined &&
      this.optionMap[this.value]
    ) {
      this.text = this.optionMap[this.value];
    } else if (!this.description && this.data.length > 0) {
      this.text = this.data[0]._value;
    }
    if (this.useDefaultIcon && !this.inlineLabel) {
      this.innerRightIcon = images.triangle;
    }
  },
  props: {
    label: String,
    image: String,
    leftIcon: String,
    rightIcon: String,
    useDefaultIcon: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    inlineLabel: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: "Select"
    },
    getKey: {
      type: Function,
      default: opt => opt.key
    },
    getValue: {
      type: Function,
      default: opt => opt.value
    }
  },
  data() {
    return {
      text: "",
      showOptions: false,
      showOptionsLock: false,
      innerRightIcon: this.rightIcon
    };
  },
  computed: {
    noOptions() {
      return Object.keys(this.options).length === 0;
    },
    data() {
      return this.options.map(x => {
        x._key = this.getKey(x);
        x._value = this.getValue(x);
        return x;
      });
    },
    optionMap() {
      let obj = {};
      this.options.forEach(x => (obj[this.getKey(x)] = this.getValue(x)));
      return obj;
    }
  },
  methods: {
    refreshTextByKey(key) {
      if (!key) {
        this.text = "";
        return;
      }
      let current = this.data.find(x => x._key == key);
      if (current && current._value) {
        this.text = current._value;
      }
    },
    keypress: function(e) {
      let key = e.key || e.code;
      let code = e.keyCode || e.which;

      if (
        code === 13 ||
        key === "Enter" ||
        code === 27 ||
        key === "Escape" ||
        code === 9 ||
        key === "Tab"
      ) {
        e.target.blur();
      }
    },
    setFocus(e) {
      e.preventDefault();
      this.showOptions = !this.showOptions;
      e.currentTarget.querySelector("input").focus();
      return false;
    },
    inputBlur() {
      if (this.showOptions && !this.showOptionsLock) {
        this.showOptions = false;
      }
    },
    changeValue(val) {
      this.showOptions = false;
      this.$emit("input", val);
      this.refreshTextByKey(val);
    }
  }
};
</script>